// src/modules/common/components/Typography/withEmphasis/withEmphasis.jsx
/* eslint-disable react/forbid-foreign-prop-types */
import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { NAMESPACE } from "../../../namespace";
import { TYPOGRAPHY_CSS } from "../../../constants";
import "./withEmphasis.css";

const withEmphasis = (Element) => {
  return class WithEmphasis extends PureComponent {
    static propTypes = {
      ...Element.propTypes,
      bold: PropTypes.bool,
      italic: PropTypes.bool,
      underline: PropTypes.bool,
      strikethrough: PropTypes.bool,
      className: PropTypes.string,
    };

    static defaultProps = {
      ...Element.defaultProps,
      bold: false,
      italic: false,
      underline: false,
      strikethrough: false,
      className: "",
    };

    render() {
      const {
        className,
        bold,
        italic,
        underline,
        strikethrough,
        ...props
      } = this.props;
      const boldClass = bold ? ` ${TYPOGRAPHY_CSS.BOLD}` : "";
      const italicClass = italic ? ` ${TYPOGRAPHY_CSS.ITALIC}` : "";
      const underlineClass = underline ? ` ${TYPOGRAPHY_CSS.UNDERLINE}` : "";
      const strikethroughClass = strikethrough
        ? ` ${TYPOGRAPHY_CSS.STRIKETHROUGH}`
        : "";
      const composeClassName = `${NAMESPACE}WithEmphasis${boldClass}${italicClass}${underlineClass}${strikethroughClass} ${className}`.trim();
      return <Element {...props} className={composeClassName} />;
    }
  };
};

export default withEmphasis;
